function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 3C0 1.89543 0.895431 1 2 1H18C19.1046 1 20 1.89543 20 3V15C20 16.1046 19.1046 17 18 17H2C0.895431 17 0 16.1046 0 15V3Z",
  fill: "#C192DE"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0028 8.80322C10.7644 8.80322 11.377 8.18508 11.377 7.42344C11.377 6.66179 10.7644 6.04365 10.0028 6.04365C9.24112 6.04365 8.62298 6.66179 8.62298 7.42344C8.62298 8.18508 9.24112 8.80322 10.0028 8.80322ZM5.8634 8.25131C6.77958 8.25131 7.51363 7.51174 7.51363 6.59556C7.51363 5.67939 6.77958 4.93982 5.8634 4.93982C4.94723 4.93982 4.20766 5.67939 4.20766 6.59556C4.20766 7.51174 4.94723 8.25131 5.8634 8.25131ZM10.0028 9.90705C8.99276 9.90705 6.96724 10.4148 6.96724 11.4248V12.6666H13.0383V11.4248C13.0383 10.4148 11.0128 9.90705 10.0028 9.90705ZM5.8634 9.35514C4.57744 9.35514 2 10.0009 2 11.2868V12.6666H5.8634V11.4248C5.8634 10.9557 6.04554 10.1333 7.17144 9.50968C6.69128 9.41033 6.22767 9.35514 5.8634 9.35514Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.4864 6.59556C12.4864 7.51174 13.2204 8.25131 14.1366 8.25131C15.0528 8.25131 15.7923 7.51174 15.7923 6.59556C15.7923 5.67939 15.0528 4.93982 14.1366 4.93982C13.2204 4.93982 12.4864 5.67939 12.4864 6.59556Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18 11.2868C18 10.0009 15.4226 9.35514 14.1366 9.35514C13.7723 9.35514 13.3087 9.41033 12.8286 9.50968C13.9545 10.1333 14.1366 10.9557 14.1366 11.4248V12.6666H18V11.2868Z",
  fill: "white"
});

function SvgConfEnabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfEnabled);
export default __webpack_public_path__ + "static/media/conf_enabled.e7916a9f.svg";
export { ForwardRef as ReactComponent };